import React from 'react';
import { ProgressionList } from '@/components/chord_progression/converter/progression_list/ProgressionList';
import { Progression } from '@/components/chord_progression/converter/types';

export const DegreeProgressionList = (props: {
  degreeProgressions: Progression[];
}) => {
  const romanProgressions = props.degreeProgressions.map((progression) => {
    const romanChords = progression.value.map((arabicChord) => {
      return arabicChord
        .replace(/^1/, 'I')
        .replace(/^2/, 'II')
        .replace(/^3/, 'III')
        .replace(/^4/, 'IV')
        .replace(/^5/, 'V')
        .replace(/^6/, 'VI')
        .replace(/^7/, 'VII')
        .replace(/\/1/, '/I')
        .replace(/\/2/, '/II')
        .replace(/\/3/, '/III')
        .replace(/\/4/, '/IV')
        .replace(/\/5/, '/V')
        .replace(/\/6/, '/VI')
        .replace(/\/7/, '/VII');
    });

    return { ...progression, value: romanChords };
  });

  return (
    <ProgressionList
      label="選んだキーで度数に変換すると"
      progressions={romanProgressions}
    />
  );
};
